export default "__VITE_ASSET__BgOabd5z__"